import TranslatedText from "@components/items/display/TranslatedText";

import { Profile } from "./Profile";
import AccountSettingsTab from "@components/layouts/b2c/profile/settings/AccountSettingsTab";
import VouchersTab from "@components/layouts/b2c/profile/vouchers/VouchersTab";
import { useEffect, useState } from "react";
import SubscriptionHistoryTab from "@components/layouts/b2c/profile/subscription/SubscriptionHistoryTab";
import WajeezCompaniesTab from "@components/layouts/b2c/profile/companies/WajeezCompaniesTab";
import ReadingandListeningSettingsTab from "@components/layouts/b2c/profile/readingandlistening/ReadingandListeningSettingsTab";
import {
  getQueryFromUrl,
  updateQueryParam,
} from "@utils/helpers/getQueryFromUrl";
import useCurrentPlan from "@utils/hooks/useCurrentPlan";
import { useB2B } from "@modules/content/B2BContext";

type Tab = {
  value: string;
  label: string | JSX.Element;
  content: string | JSX.Element;
};

export const Settings = () => {
  const tabParam = getQueryFromUrl("tab");
  const [selectedTab, setSelectedTab] = useState<Tab>();
  const { plan: currentPlan } = useCurrentPlan();
  const { b2B } = useB2B();

  const tabs = [
    ...(!b2B?.isB2B
      ? [
          {
            label: <TranslatedText text={`settings.tabs.profile`} />,
            value: "profile",
            content: <Profile />,
          },
        ]
      : []),
    {
      label: <TranslatedText text={`settings.tabs.settings`} />,
      value: "account",
      content: <AccountSettingsTab />,
    },
    ...(!currentPlan?.isFree
      ? [
          {
            label: <TranslatedText text={`settings.tabs.subscription`} />,
            value: "subscription",
            content: <SubscriptionHistoryTab currentPlan={currentPlan} />,
          },
        ]
      : []),
    {
      label: (
        <TranslatedText
          text={`settings.tabs.${"reading and listening settings"}`}
        />
      ),
      value: "content",
      content: <ReadingandListeningSettingsTab />,
    },
    {
      label: <TranslatedText text={`settings.tabs.vouchers`} />,
      value: "voucher",
      content: <VouchersTab />,
    },
    {
      label: <TranslatedText text={`settings.tabs.${"wajeez companies"}`} />,
      value: "b2BVoucher",
      content: <WajeezCompaniesTab />,
    },
  ];

  useEffect(() => {
    if (tabParam) {
      setSelectedTab(tabs.find((t) => t.value === tabParam));
    }
  }, [tabParam]);

  const renderTabs = () => {
    return tabs.map((t) => {
      return (
        <div
          key={t.value}
          className={`border-b px-[22px] pb-[10px] ${
            selectedTab?.value === t.value
              ? "border-b-primary text-primary"
              : "border-b-black text-black dark:border-b-white dark:text-white"
          } cursor-pointer text-[17px] font-medium`}
          style={{ WebkitTapHighlightColor: "transparent" }}
          onClick={() => {
            updateQueryParam("tab", t.value);

            setSelectedTab(t);
          }}
        >
          {t.label}
        </div>
      );
    });
  };

  return (
    <div className="flex h-full flex-col items-start justify-start px-4 py-24 sm:p-8">
      <div className="flex w-full items-center justify-center">
        {renderTabs()}
      </div>
      <div className="cus-scrollbar-w-none mb-auto w-full overflow-y-auto">
        {tabs.find((t) => t.value === selectedTab?.value)?.content}
      </div>
    </div>
  );
};
